import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Grid,
  Header,
  Icon,
  Modal,
} from 'semantic-ui-react';

export default class ManageSettingsModal extends Component {
  static propTypes = {
    open: PropTypes.bool,
    onSave: PropTypes.func,
  }
  static getPropsToState = (props) => {
    const open = props.open;
    return {
      open,
    };
  }
  constructor(props) {
    super(props);
    const state = ManageSettingsModal.getPropsToState(props);
    this.state = {
      ...state,
    };
  }
  componentWillReceiveProps(nextProps) {
    const state = ManageSettingsModal.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  close(callback) {
    this.setState({
      open: false,
    }, () => {
      if (callback) {
        callback();
      }
    });
  }
  handleOnClose = () => {
    this.close();
  }
  handleSave = () => {
    this.props.onSave();
  }
  render() {
    return (
      <Modal
        basic
        open={this.state.open}
        onClose={this.handleOnClose}
        closeIcon="close"
        size="small"
      >
        <Header>
            <img alt="e-signing" src="/assets/images/icons/credit_check.svg" /> Credit Check Settings
        </Header>
        <Modal.Content>
          <Grid>
            <Grid.Row>
              <Grid.Column>
                <p>
                    Take note that all your pending UNAPPROVED credit check will NOT be automatically approved
                </p>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Modal.Content>
        <Modal.Actions>
            <Button
            basic
            color='red'
            inverted
            onClick={this.handleOnClose}
            >
                <Icon name='remove' /> Cancel
            </Button>
            <Button
            color='green'
            inverted
            onClick={this.handleSave}
            >
                <Icon name='checkmark' /> Save
            </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/CreditCheck/ManageSettingsModal.jsx